(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tavohudis-home-hero"] && !Shopify.designMode) return;
  try {
    
  class HeroCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.th-home-hero__track');
      this.slides = Array.from(this.querySelectorAll('.th-home-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.th-home-hero__dot'));
      this.index = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.slides.length > 1) {
        this.clone = this.slides[0].cloneNode(true);
        this.clone.removeAttribute('data-shopify-editor-block');
        this.clone.setAttribute('data-carousel-clone', 'true');
        const cloneHeading = this.clone.querySelector('h1');
        if (cloneHeading) {
          const replacement = document.createElement('div');
          replacement.className = cloneHeading.className;
          replacement.innerHTML = cloneHeading.innerHTML;
          cloneHeading.replaceWith(replacement);
        }
        this.track.appendChild(this.clone);
      }
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.slide), true)));
      this.track.addEventListener('transitionend', () => this.resetLoop());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.start();
      });
      this.addEventListener('touchstart', (event) => {
        this.touchStartX = event.touches[0].clientX;
      }, { passive: true });
      this.addEventListener('touchend', (event) => {
        if (this.touchStartX === null) return;
        const distance = event.changedTouches[0].clientX - this.touchStartX;
        if (Math.abs(distance) > 50) {
          if (distance < 0) this.advance(true); else this.goTo(this.index - 1, true);
        }
        this.touchStartX = null;
      }, { passive: true });
      this.render();
      this.start();
    }

    goTo(index, restart) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transition = '';
      this.render(this.index);
      if (restart) {
        this.stop();
        this.start();
      }
    }

    advance(restart) {
      if (this.index >= this.slides.length - 1 && this.clone) {
        this.index = this.slides.length;
        this.track.style.transition = '';
        this.render(0, true);
      } else {
        this.index += 1;
        this.track.style.transition = '';
        this.render(this.index);
      }
      if (restart) {
        this.stop();
        this.start();
      }
    }

    resetLoop() {
      if (this.index !== this.slides.length) return;
      this.track.style.transition = 'none';
      this.index = 0;
      this.render(0);
      this.track.getBoundingClientRect();
      window.requestAnimationFrame(() => { this.track.style.transition = ''; });
    }

    render(activeIndex = this.index, showClone = false) {
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, index) => {
        const active = index === activeIndex && !showClone;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.toggleAttribute('inert', !active);
      });
      if (this.clone) {
        this.clone.setAttribute('aria-hidden', showClone ? 'false' : 'true');
        this.clone.toggleAttribute('inert', !showClone);
      }
      this.dots.forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    start() {
      if (this.reducedMotion || this.slides.length < 2 || this.timer) return;
      this.timer = window.setInterval(() => this.advance(false), 5000);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

  }

  if (!customElements.get('tavohudis-hero-carousel')) customElements.define('tavohudis-hero-carousel', HeroCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tavohudis-reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.th-reviews__track');
      this.slides = Array.from(this.querySelectorAll('.th-reviews__slide'));
      this.pagination = this.querySelector('[data-review-pagination]');
      this.index = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.mobile = window.matchMedia('(max-width: 749px)');
      if (this.slides.length < 2) return;
      this.createDots();
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.mobile.addEventListener('change', () => {
        this.index = 0;
        this.createDots();
        this.render();
      });
      this.render();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    move(direction) {
      this.index = (this.index + direction + this.pageCount()) % this.pageCount();
      this.render();
      this.start();
    }

    render() {
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      if (this.dots) {
        this.dots.forEach((dot, dotIndex) => {
          if (dotIndex === this.index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    createDots() {
      if (!this.pagination) return;
      this.pagination.replaceChildren();
      this.dots = Array.from({ length: this.pageCount() }, (_, dotIndex) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'th-reviews__dot';
        dot.setAttribute('aria-label', `Rādīt ${dotIndex + 1}. atsauksmju grupu`);
        dot.addEventListener('click', () => {
          this.index = dotIndex;
          this.render();
          this.start();
        });
        this.pagination.append(dot);
        return dot;
      });
    }

    pageCount() {
      return Math.ceil(this.slides.length / (this.mobile.matches ? 1 : 3));
    }

    start() {
      this.stop();
      if (this.reducedMotion) return;
      this.timer = window.setInterval(() => this.move(1), 3500);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
    }
  }

  if (!customElements.get('review-carousel')) customElements.define('review-carousel', ReviewCarousel);

  } catch(e) { console.error(e); }
})();
})();
